var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7071 5.32414C21.0976 5.71467 21.0976 6.34783 20.7071 6.73836L9.70711 17.7384C9.31658 18.1289 8.68342 18.1289 8.29289 17.7384L3.29289 12.7384C2.90237 12.3478 2.90237 11.7147 3.29289 11.3241C3.68342 10.9336 4.31658 10.9336 4.70711 11.3241L9 15.617L19.2929 5.32414C19.6834 4.93362 20.3166 4.93362 20.7071 5.32414Z",
    fill: "#69C23F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck0);
export default __webpack_public_path__ + "static/media/green-check0.4a9c8571fec6f80b5318d6e2349d8852.svg";
export { ForwardRef as ReactComponent };